import PropTypes from "prop-types";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import InfoButton from "@/components/Header/Button/InfoButton";
import HeaderButtonList from "@/components/Header/HeaderButtonList/HeaderButtonList";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";
import AssetEdit from "@/features/Assets/AssetEdit";
import { AssetDuplicateButton } from "@/modules/asset/asset-duplicate";
import { AssetInfo } from "@/modules/asset/asset-info";
import { useAuthorization } from "@/modules/authorization";
import ModelFavoriteButton from "@/modules/model-favorite-button";
import { useSidePanel } from "@/modules/side-panel";
import { StateEditForm } from "@/modules/state-edit-form";
import { EditButton } from "@/ui/edit-button";

const HeaderButtons = ({ asset = {} }) => {
  const { openSidePanel } = useSidePanel();
  const { canCreate, canUpdate, canDelete } = useAuthorization();

  const onEditClick = () => {
    openSidePanel({
      title: asset.name,
      component: <AssetEdit assetId={asset.id} />,
    });
  };

  const onInfoSelect = () => {
    openSidePanel({
      title: asset.name,
      component: <AssetInfo asset={asset} />,
    });
  };

  const primaryActions = [];

  if (canUpdate(asset)) {
    primaryActions.push(
      <StateEditForm key="stateEdit" stateType="asset" model={asset} />
    );
  }

  primaryActions.push(<InfoButton key="info" onInfoSelect={onInfoSelect} />);

  primaryActions.push(
    <ModelFavoriteButton
      key={BUTTON_KEYS.FAVORITE}
      modelKey="asset"
      item={asset}
    />
  );

  const secondaryActions = [];
  if (canUpdate(asset)) {
    secondaryActions.push({
      key: BUTTON_KEYS.EDIT,
      label: (
        <EditButton key={BUTTON_KEYS.EDIT} type="text" onClick={onEditClick} />
      ),
    });
  }

  if (canCreate("asset")) {
    secondaryActions.push({
      key: BUTTON_KEYS.DUPLICATE,
      label: (
        <AssetDuplicateButton
          key={BUTTON_KEYS.DUPLICATE}
          asset={asset}
          type="text"
          showIcon
        />
      ),
    });
  }

  if (canDelete(asset)) {
    secondaryActions.push({
      key: BUTTON_KEYS.DELETE,
      label: (
        <DeleteButton
          key={BUTTON_KEYS.DELETE}
          modelKey="asset"
          model={asset}
          buttonProps={{
            type: BUTTON_TYPE.TEXT,
          }}
        />
      ),
    });
  }

  return (
    <HeaderButtonList
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
    />
  );
};

HeaderButtons.propTypes = {
  asset: PropTypes.object.isRequired,
};

export default HeaderButtons;
